import { render } from "./YoutubePlayer.vue?vue&type=template&id=ac75b75a&scoped=true"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"

import "./YoutubePlayer.vue?vue&type=style&index=0&id=ac75b75a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdc-frontend/abdc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac75b75a"]])

export default __exports__